/*
 *
 * OperationActionsModal
 *
 * @version 1.0.0
 * @author Davide Campus
 * @since 31-Oct-2024
 */

import OperationActionsModal from './OperationActionsModalContainer'

export default OperationActionsModal
